(function () {
  var KEY = 'mn_trust_dialog';
  var root = document.querySelector('[data-mn-trust]');
  if (!root) return;
  if (window.location.search.indexOf('mn_trust=1') === -1 && window.localStorage.getItem(KEY)) return;

  var acceptBtn = root.querySelector('[data-mn-trust-accept]');
  var necessaryBtn = root.querySelector('[data-mn-trust-necessary]');
  var shown = false;

  function hide() {
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    window.setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-closing');
    }, 280);
  }

  function setConsent(allow, done) {
    var finish = typeof done === 'function' ? done : hide;
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.setTrackingConsent === 'function') {
        Shopify.customerPrivacy.setTrackingConsent(allow, finish);
        return;
      }
    } catch (e) {}
    finish();
  }

  function choose(allow) {
    try {
      window.localStorage.setItem(KEY, allow ? 'accept' : 'necessary');
    } catch (e) {}
    setConsent(allow, hide);
  }

  function open() {
    if (shown) return;
    shown = true;
    root.hidden = false;
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
  }

  function bind() {
    if (acceptBtn) acceptBtn.addEventListener('click', function () { choose(true); });
    if (necessaryBtn) necessaryBtn.addEventListener('click', function () { choose(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) choose(false);
    });
  }

  var started = false;
  function startOnce() {
    if (started) return;
    started = true;
    bind();
    window.setTimeout(open, 1200);
  }

  if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () {
        startOnce();
      }
    );
    window.setTimeout(startOnce, 2500);
  } else {
    startOnce();
  }
})();
